module.exports = __webpack_public_path__ + "media/images/fill-48e50b101e8ae095a4ab50444c245687.png";